export const NOTIFICATION_SETTING = {
  weeklyMaintenance: "Weekly Maintenance",
  monthlyMaintenance: "Monthly Maintenance",
  runModeError: "Error",
  preventsWashing: "Box prevents washing",
} as const;

export type Subscriber = {
  name: string;
  email?: string;
  phone?: string;
  notifyPhone: boolean;
  notifyEmail: boolean;
};
export type NotificationSetting = {
  notificationSetting: keyof typeof NOTIFICATION_SETTING;
  display: (typeof NOTIFICATION_SETTING)[keyof typeof NOTIFICATION_SETTING];
  subscribers: Subscriber[];
};

export type DisplayNotificationSetting = {
  [K in keyof typeof NOTIFICATION_SETTING]?: {
    notifyPhone: boolean;
    notifyEmail: boolean;
  };
} & Omit<Subscriber, "notifyEmail" | "notifyPhone">;
